import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { FilterSelection } from './filter-selection';

export const FilterSelectionModule: string = ng
    .module('filter-selection', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('filterSelection', FilterSelection)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/filter-selection/filter-selection.module.ts